import { inject } from '@angular/core';

import { filter, first } from 'rxjs';

import { Store } from '@ngrx/store';

import { accountFeatureActions } from '../../state/account/actions/account-feature.actions';
import { selectUserName } from '../../state/account/account.selectors';

export const accountConfigFactory = (store = inject(Store)) => {
  store.dispatch(accountFeatureActions.loadAccountInformation());

  return store.select(selectUserName).pipe(
    filter((userName) => userName !== null),
    first(),
  );
};
